var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, SimplePagination, Spinner } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import styles from './customTab.module.scss';
import ListGroups from './listGroups';
import ListNumbers from './listNumbers';
export default class CustomTab extends PureComponent {
    get results() {
        const { type, phoneSearch: { items }, } = this.props;
        return items[type];
    }
    handleNext() {
        const { phoneSearch: { nextPage }, type, } = this.props;
        nextPage(type);
    }
    handlePrev() {
        const { phoneSearch: { previousPage }, type, } = this.props;
        previousPage(type);
    }
    renderLoadingStatus() {
        const { type, phoneSearch } = this.props;
        const { getItemsAsyncStatus, getItems } = phoneSearch;
        const { numbers, groups, country } = this.results || {};
        if (getItemsAsyncStatus === 'succeeded' &&
            (numbers === null || numbers === void 0 ? void 0 : numbers.length) === 0 &&
            (groups === null || groups === void 0 ? void 0 : groups.length) === 0 &&
            country) {
            return (_jsx("div", { children: _jsxs("span", Object.assign({ className: "text-center" }, { children: ["No ", type === 'geographic' ? 'local' : type, " numbers found", ' ', _jsxs("strong", { children: ["in", ' ', _jsx("strong", Object.assign({ className: "text-capitalize" }, { children: country.country.toLowerCase() }))] }), ". Contact Dixa if you need a number."] })) }));
        }
        if (getItemsAsyncStatus === 'loading') {
            return (_jsx("div", Object.assign({ className: styles.loading }, { children: _jsx(Spinner, {}) })));
        }
        if (getItemsAsyncStatus === 'failed') {
            return (_jsxs("div", Object.assign({ className: "row-item telephony__empty" }, { children: [_jsx("span", { children: "Error while fetching numbers..." }), _jsx(Button, Object.assign({ type: "button", variant: "tertiary", onClick: () => getItems({ country }, [type]) }, { children: "Try again" }))] })));
        }
        return null;
    }
    renderPaginationButtons() {
        const results = this.results;
        const { phoneSearch } = this.props;
        return (_jsx(SimplePagination, { previousButtonClick: this.handlePrev, previousButtonDisabled: !(results === null || results === void 0 ? void 0 : results.previousPagePath), nextButtonClick: this.handleNext, nextButtonDisabled: !(results === null || results === void 0 ? void 0 : results.nextPagePath), hidden: phoneSearch.getItemsAsyncStatus === 'loading' }));
    }
    renderNumbers() {
        const { buyNumber } = this.props;
        const { numbers, country } = this.results || {};
        if (!numbers || !country) {
            return null;
        }
        return numbers.map((number) => (_jsx(ListNumbers, { number: number, country: country, showBuyNumberModal: buyNumber }, number.phone_number.e164_format)));
    }
    renderGroups() {
        const { buyNumber } = this.props;
        const { groups, country } = this.results || {};
        if (!groups || !country) {
            return null;
        }
        return groups.map((group, index) => (_jsx(ListGroups, { group: group, country: country, showBuyNumberModal: buyNumber }, index)));
    }
    render() {
        const { phoneSearch: { getItemsAsyncStatus }, } = this.props;
        const isLoading = getItemsAsyncStatus !== 'succeeded';
        return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsxs("div", Object.assign({ className: styles.list }, { children: [this.renderLoadingStatus(), !isLoading && this.renderNumbers(), !isLoading && this.renderGroups()] })), _jsx("div", Object.assign({ className: styles.buttons }, { children: this.renderPaginationButtons() }))] })));
    }
}
__decorate([
    boundMethod
], CustomTab.prototype, "handleNext", null);
__decorate([
    boundMethod
], CustomTab.prototype, "handlePrev", null);
